/**
 * Calculate percentage value for a specific item in chart data.
 *
 * @param {Array<{ value: number, key: string }>} data
 *        Chart data source. Each item must contain a numeric `value`
 *        and a unique `name`.
 *
 * @param {string} targetName
 *        The name of the target item to calculate percentage for.
 *
 * @returns {number}
 *          Rounded percentage (0–100).
 *
 * @example
 * const data = [
 *   { key: 'xxxxx', value: 242 },
 *   { key: 'iiiii', value: 130 }
 * ];
 *
 * const percent = getPercent(data, '已訂購');
 * // → 65
 */
const getPercent = (data, targetName) => {
	const total = data.reduce((s, d) => s + d.value, 0);
	const target = data.find(d => d.key === targetName)?.value ?? 0;
	return Math.round((target / total) * 100);
};

// 只能用字串模板，請勿用ReactComponent，回傳直只接受String型別
const tooltipFormatter = ({ name, value, percent }) => {
	return `
		<strong>${name}</strong><br/>
		${value} 人（${Math.round(percent)}%）
	`;
};

export { getPercent, tooltipFormatter };
